import {MOON_250, MOON_800} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const LinksDrawer = styled.div`
  flex-direction: column;
  display: flex;
  height: 100%;
`;
LinksDrawer.displayName = 'S.LinksDrawer';

export const LinksDrawerMain = styled.div`
  flex: 1 1 auto;
`;
LinksDrawerMain.displayName = 'S.LinksDrawerMain';

export const Header = styled.div`
  font-family: Source Sans Pro;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px;
`;
Header.displayName = 'S.Header';

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
`;
HeaderRow.displayName = 'S.HeaderRow';

export const RightButton = styled.div`
  text-align: right;
  flex: 1 1 auto;
  float: right;
`;
RightButton.displayName = 'S.RightButton';

export const FormLabel = styled.div`
  color: ${MOON_800};
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  margin-top: 32px;
  flex 1 1 auto;
`;

export const FormText = styled.div`
  margin-right: 32px;
`;

export const UnderLine = styled.div`
  height: 1px;
  background: ${MOON_250};
  padding: 0;
  width: 100%;
  position: absolute;
  margin-left: -20px;
  margin-top: 16px;
`;

export const LinksDrawerSecondary = styled.div`
  position: absolute;
  bottom: 16px;
  left: 16px;
  right: 16px;
`;
LinksDrawerSecondary.displayName = 'S.LinksDrawerSecondary';
